$(function () {
    if (!$('body').hasClass('post-type-archive-listing')) return;

    function removeFilterParams(paramsToRemove) {
        const url = new URL(window.location.href);
        const searchParams = url.searchParams;
    
        paramsToRemove.forEach(param => searchParams.delete(param));
    
        // Update the URL without reloading the page
        window.history.replaceState(null, "", url.pathname + "?" + searchParams.toString());
    }
    
    removeFilterParams(["filtering"]);
});